import React, { useState } from "react";
import FormSignup from "./FormSignup";
import Success from "./Success";

const Form = () => {
  const [isSubmitted, setIsSubmitted] = useState(false);
  function submitForm() {
    setIsSubmitted(true);
  }
  return (
    <>
      <div className="form-container">
        {!isSubmitted ? <FormSignup submitForm={submitForm} /> : <Success />}
      </div>
    </>
  );
};

export default Form;
